// extracted by mini-css-extract-plugin
export default {"root":"fTYpEScwimsR9YFdkojA","header":"diHazPHwcJp8qs_ipcYV","title":"jqw0pL49WDUPiUEgVYD2"};